export default function PageLoader() {
  return (
    <div className="grid min-h-[50vh] place-items-center">
      <div className="h-10 w-10 animate-spin rounded-full border-2 border-ink/15 border-t-brand-500" />
    </div>
  );
}
